import { Box, Typography } from '@mui/material';
import {uhuzamlogo} from '../constants/logos';

const ProjectTitle = () => {
  return (
    <>
      <Box
        component="img"
        sx={{
          height: 100,
          width: 270,
        }}
        src={uhuzamlogo}
      />
      <Typography variant="h5" color="text.primary" align="center">
        TARSİS
      </Typography>
      <br />
    </>
  );
};

export default ProjectTitle;
